import Loading from '../../../Common/Loading';
import { useVaccinationChartsDataContext } from './hooks/useVaccinationChartsDataContext';
import { Indicators } from './Indicators';
import { VaccinatedKidsUnderOneYearWithPenta } from './VaccinatedKidsUnderOneYearWithPenta';
import { VaccinatedKidsUnderOneYearWithHB } from './VaccinatedKidsUnderOneYearWithHB';
import { VaccinatedKidsUnderOneYearWithVIP } from './VaccinatedKidsUnderOneYearWithVIP';
import { TotalVaccinationByStrategy } from './TotalVaccinationByStrategy';
import { TotalVaccinationByYear } from './TotalVaccinationByYear';
import { TotalVaccinationByImmunoBiological } from './TotalVaccinationByImmunoBiological';
import { TotalVaccinationByMonth } from './TotalVaccinationByMonth';
import { TotalVaccinationByAge } from './TotalVaccinationByAge';

export const Charts = () => {
    const { isLoading } = useVaccinationChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Indicators />
            <div className="charts-side-by-side-dashboards">
                <VaccinatedKidsUnderOneYearWithPenta />
                <VaccinatedKidsUnderOneYearWithHB />
            </div>
            <div className="charts-side-by-side-dashboards">
                <VaccinatedKidsUnderOneYearWithVIP />
                <TotalVaccinationByStrategy />
            </div>
            <div className="charts-side-by-side-dashboards">
                <TotalVaccinationByYear />
                <TotalVaccinationByImmunoBiological />
            </div>
            <div className="charts-side-by-side-dashboards">
                <TotalVaccinationByAge />
                <TotalVaccinationByMonth />
            </div>
        </>
    );
};
